import feature from 'vue-feature-toggle';

declare global {
  interface Window {
    updateFlag: (_name: string, _value: boolean) => void;
  }
}

// we use it like this: updateFlag('sso', true); inside the console
const flags = ['plans', 'payments', 'notifications', 'sso', 'licence'];

export const initializeFeatureFlags = () => {
  flags.forEach((flag) => {
    try {
      const storedValue = sessionStorage.getItem(flag);
      const value = storedValue === '1';
      sessionStorage.setItem(flag, value ? '1' : '0');
      feature.setFlag(flag, value);
    } catch (error) {
      console.error(`Error initializing feature flag "${flag}":`, error);
    }
  });
};

export const updateFlag = (name: string, value: boolean) => {
  const key = name.toLowerCase();

  if (!flags.includes(key)) {
    console.warn(`Feature flag "${name}" is not recognized.`);
    return;
  }

  try {
    sessionStorage.setItem(key, value ? '1' : '0');
    feature.setFlag(key, value);
    window.location.reload();
  } catch (error) {
    console.error(`Error updating feature flag "${key}":`, error);
  }
};

window.updateFlag = updateFlag;
